// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--cghar","main-article-wrapper":"_9e1425b4d3--main-article-wrapper--dHguo"};